import { classNames } from 'primereact/utils';
import React from 'react';
import { useAppSelector } from '../../hooks/hooks.js';
import { selectMode, selectShowDndHint } from '../../store/reducers/enginePropertiesSlice.js';
import img from '../../assets/dndIcon.png.js';

const C2Column = (props) => {
    var _a;
    const { children, noGutter, cols } = props;
    const mode = useAppSelector(selectMode);
    const showDndHint = useAppSelector(selectShowDndHint);
    const colClass = cols ? `col-${cols}` : "col";
    const classes = classNames({
        [colClass]: mode === "live",
        "no-gutter": mode === "live" && noGutter,
    }, props.className, "flex");
    ({
        border: "1px dashed #ccc",
        height: "inherit !important",
        minHeight: ((_a = props.className) === null || _a === void 0 ? void 0 : _a.includes("h-")) ? "unset" : "100px",
    });
    const style = mode !== "live" ? props.style : props.style;
    return showDndHint ? (React.createElement("div", { className: "w-full h-full flex gap-2 align-items-center justify-content-center empty-helper", style: Object.assign({}, style) },
        React.createElement("div", { className: "w-4 border-round-2xl border-dashed border-indigo-300 bg-indigo-50 flex flex-column align-items-center", style: { minWidth: "12rem" } },
            React.createElement("img", { src: img, height: "64px", width: "64px", className: "mt-5 mb-3" }),
            React.createElement("div", { className: "w-10 mb-3 text-center text-lg text-white-700 font-medium line-height-3" }, "Pick components from the menu on the left and drag & drop them into the screen")))) : (React.createElement("div", Object.assign({}, props, { className: classes, style: style, ref: el => {
            if (el && mode !== "live") {
                el.style.setProperty('height', 'inherit', 'important');
            }
        } }), children));
};

export { C2Column };
//# sourceMappingURL=C2Column.js.map
